import React from 'react'

const AttendeeSection = () => {
  return (
    <section className='attendee-section page-width px-3 my-5 py-5'>
        <h2 className="text-center text-uppercase py-5 mt-5">WHO IS THIS CONFERENCE FOR?</h2>

        <section className="attendee-section_details d-flex flex-wrap justify-content-start mb-0 mb-md-5 pb-0 pb-md-5">
            <div className="topic-card topic-card1"><p>real estate agencies</p></div>
            <div className="topic-card topic-card2"><p>media agencies</p></div>
            <div className="topic-card topic-card3"><p>entrepreneurs</p></div>
            <div className="topic-card topic-card4"><p>church leaders</p></div>
            <div className="topic-card topic-card5"><p>families</p></div>
            <div className="topic-card topic-card6"><p>business developers</p></div>
            <div className="topic-card topic-card7"><p>product developers</p></div>
            <div className="topic-card topic-card8"><p>Start-ups</p></div>
            <div className="topic-card topic-card9"><p>innovators</p></div>
            <div className="topic-card topic-card10"><p>urban developers</p></div>
            <div className="topic-card topic-card11"><p>architects</p></div>
            <div className="topic-card topic-card12"><p>visual designers</p></div>
            <div className="topic-card topic-card13"><p>visual designers</p></div>
            <div className="topic-card topic-card14"><p>INTERIOR designers</p></div>
            <div className="topic-card topic-card15"><p>ANALYST</p></div>
            <div className="topic-card topic-card16"><p>Software developers</p></div>
            <div className="topic-card topic-card17"><p>Project managers</p></div>
            <div className="topic-card topic-card18"><p>Product designers</p></div>
            <div className="topic-card topic-card19"><p>graphic designers</p></div>
            <div className="topic-card topic-card20"><p>motion deisigners</p></div>
            <div className="topic-card topic-card21"><p>videographers</p></div>
            <div className="topic-card topic-card22"><p>photographers</p></div>
            <div className="topic-card topic-card23"><p>music  artiste</p></div>
            <div className="topic-card topic-card24"><p>content creators</p></div>
        </section>
    </section>
  )
}

export default AttendeeSection